import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

import { totalViewsConfig } from '../totalViews';

export const mediaViewerViewsConfig = {
    ...totalViewsConfig,
    id: 'video_views',
    name: 'kpi.twitter.mediaviewer.views',
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
